/* The Gadget World — scroll-in motion (Motion / motion.dev) */
import { animate, inView } from "https://cdn.jsdelivr.net/npm/motion@11.11.13/+esm";

if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  var SEL = ".product-card,.hm-cat,.category-card,.hm-ptile,.hm-h1,.hm-h2,.section-title,.trust-item,.apple-card,.promo-badge-card";
  // Hide only AFTER the library loaded, so a failed import never leaves content hidden
  document.querySelectorAll(SEL).forEach(function (el) {
    el.style.opacity = "0";
    el.style.willChange = "opacity, transform";
  });
  inView(SEL, function (info) {
    animate(
      info.target,
      { opacity: [0, 1], transform: ["translateY(22px)", "translateY(0)"] },
      { duration: 0.55, easing: [0.16, 1, 0.3, 1] }
    );
    return function () {}; // run once
  }, { amount: 0.12 });
}
